module.exports = __webpack_public_path__ + "static/002_001-e65d47ba9cdec2cde4596c1cbd00b651.jpg";